import React, { FC, PropsWithChildren } from 'react';

const OnboardingLayout: FC<PropsWithChildren> = ({ children }) => {
  return <div>{children}</div>;
};

export default OnboardingLayout;
